document.documentElement.classList.remove('no-js');
document.addEventListener('DOMContentLoaded', () => {
  const toggle = document.querySelector('[data-menu-toggle]');
  const nav = document.querySelector('[data-main-nav]');
  if (toggle && nav) toggle.addEventListener('click', () => nav.classList.toggle('is-open'));

  document.querySelectorAll('[data-product-root]').forEach((root) => {
    const select = root.querySelector('[data-variant-select]');
    const price = root.querySelector('[data-price]');
    const compare = root.querySelector('[data-compare]');
    const button = root.querySelector('[data-add-button]');
    if (select) {
      select.addEventListener('change', () => {
        const option = select.options[select.selectedIndex];
        if (price) price.textContent = option.dataset.price || '';
        if (compare) {
          compare.textContent = option.dataset.compare || '';
          compare.hidden = !option.dataset.compare;
        }
        if (button) {
          const available = option.dataset.available === 'true';
          button.disabled = !available;
          button.textContent = available ? 'Kosárba teszem' : 'Elfogyott';
        }
        const imageId = option.dataset.imageId;
        if (imageId) {
          const thumb = root.querySelector(`[data-media-id="${imageId}"]`);
          if (thumb) thumb.click();
        }
      });
    }
    root.querySelectorAll('[data-thumb]').forEach((thumb) => {
      thumb.addEventListener('click', () => {
        const main = root.querySelector('[data-main-image]');
        if (main) {
          main.src = thumb.dataset.full;
          main.srcset = '';
          main.alt = thumb.dataset.alt || '';
        }
        root.querySelectorAll('[data-thumb]').forEach(t => t.classList.remove('is-active'));
        thumb.classList.add('is-active');
      });
    });
  });
});
